import styled from 'styled-components';
import { AuthFooterRow } from '../styles';

// Same line as the other auth pages' footer caption, but this one sits above
// the submit button rather than below it, so it carries the gap on its own
// bottom edge instead of its top. The last field already leaves 18px under
// itself, so only the space down to the button is set here.
export const ResendCodeRow = styled(AuthFooterRow)`
  margin-top: 0;
  margin-bottom: 14px;
`;
